import clsx from 'clsx';
import type { ComponentProps, PropsWithChildren } from 'react';
import styles from './Text.module.scss';
type TextTag = keyof HTMLElementTagNameMap;
type TextType = 'button_large' | 'button_small' | 'field_text' | 'h2' | 'h3' | 'h4' | 'p1' | 'p2' | 'p3' | 'p4' | 'p5' | 'p6';
const textTypeTagMapper: Record<TextType, TextTag> = {
  button_large: 'span',
  button_small: 'span',
  field_text: 'span',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  p1: 'span',
  p2: 'span',
  p3: 'span',
  p4: 'span',
  p5: 'span',
  p6: 'span'
};
type Props = {
  align?: 'center' | 'end' | 'start';
  className?: string;
  color?: 'asphalt' | 'basic-green' | 'black' | 'blue' | 'error' | 'green' | 'red' | 'text-gray' | 'text-silver' | 'white';
  fontWeight?: '400' | '500' | '600' | '700';
  html?: string;
  tag?: TextTag;
  type?: TextType;
} & ComponentProps<'h1'>;
export const Text = ({
  align,
  children,
  className,
  color,
  fontWeight,
  html,
  tag,
  type,
  ...props
}: PropsWithChildren<Props>) => {
  const ComponentTag: TextTag = tag ?? textTypeTagMapper[type as keyof typeof textTypeTagMapper] ?? 'div';
  return <ComponentTag {...props as Record<string, unknown>} className={clsx(type && styles[type], color && styles[`color-${color}`], align && styles[`align-${align}`], fontWeight && styles[`fontWeight-${fontWeight}`], className)} {...html && {
    dangerouslySetInnerHTML: {
      __html: html
    }
  }} data-sentry-element="ComponentTag" data-sentry-component="Text" data-sentry-source-file="Text.tsx">
      {children}
    </ComponentTag>;
};